import { Link } from "react-router-dom";
import { Clock } from "lucide-react";
import { Badge } from "@/components/ui/badge";

interface MagazineStandardCardProps {
  title: string;
  excerpt: string;
  author: string;
  readTime: number;
  image: string;
  category: string;
  slug: string;
}

export const MagazineStandardCard = ({
  title,
  excerpt,
  author,
  readTime,
  image,
  category,
  slug,
}: MagazineStandardCardProps) => {
  return (
    <Link to={`/article/${slug}`} className="block group">
      <article className="overflow-hidden">
        <div className="relative h-[250px] overflow-hidden rounded-lg mb-4">
          <div
            className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-105"
            style={{ backgroundImage: `url(${image})` }}
          />
        </div>
        
        <Badge variant="outline" className="mb-2 capitalize">
          {category}
        </Badge>
        
        <h3 className="text-2xl font-bold mb-2 line-clamp-2 group-hover:text-primary transition-colors">
          {title}
        </h3>
        
        <p className="text-muted-foreground mb-3 line-clamp-2 leading-relaxed">
          {excerpt}
        </p>
        
        <div className="flex items-center gap-3 text-sm text-muted-foreground">
          <span className="font-medium">{author}</span>
          <span className="flex items-center gap-1">
            <Clock className="h-3 w-3" />
            {readTime} min
          </span>
        </div>
      </article>
    </Link>
  );
};
